import { isEmpty } from 'lodash';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router';
import { VIEW_STATE } from 'components/MyClients/constants/applications';
import NotificationType from 'enums/Notifications/NotificationType';
import Notification from 'interfaces/Notification';

import './stylesheets/NotificationDetails.scss';
import CertificationOrTrainingOverdue from './templates/CertificationOrTrainingOverdue';
import DefaultTemplate from './templates/DefaultTemplate';
import EnrollmentStatusUpdate from './templates/EnrollmentStatusUpdate';
import ExpiringLicenses from './templates/ExpiringLicenses';

type NotificationDetailsProps = {
    notification: Notification | null;
};

const NotificationDetails = ({ notification }: NotificationDetailsProps) => {
    const navigate = useNavigate();

    const getTemplatedContent = (notification) => {
        switch (notification.type) {
            case NotificationType.ExpiringLicenses: {
                return <ExpiringLicenses notification={notification} />;
            }
            case NotificationType.CertificationOrTrainingOverdue: {
                return (
                    <CertificationOrTrainingOverdue
                        notification={notification}
                    />
                );
            }
            case NotificationType.MbiVerification:
            case NotificationType.ApplicationSuccessMbiVerificationRequired: {
                const applicationId =
                    notification?.actionMetadata?.applicationId;
                const onClick = () => {
                    navigate('/my-clients', {
                        state: {
                            pathName: '/my-clients',
                            selectedItem: 1,
                            refId: applicationId,
                            applicationView: VIEW_STATE.DETAILS,
                            showMBIVerification: true,
                            notificationType: notification?.type,
                        },
                    });
                };
                return (
                    <DefaultTemplate
                        notification={notification}
                        onClick={onClick}
                    />
                );
            }
            case NotificationType.EnrollmentStatusUpdate:
                return <EnrollmentStatusUpdate notification={notification} />;
            default:
                return <DefaultTemplate notification={notification} />;
        }
    };

    return (
        <div id="notification-details">
            {!isEmpty(notification) ? (
                <>
                    <div className="d-flex flex-column gap-3 w-100">
                        <div id="notification-details-info">
                            <span>
                                {DateTime.fromISO(
                                    notification.createdAt
                                ).toLocaleString(DateTime.DATETIME_FULL)}
                            </span>
                            <span>
                                Source: {notification.source ?? 'Not Specified'}
                            </span>
                        </div>
                        <div>
                            <span id="notification-details-subject">
                                {notification.subject}
                            </span>
                        </div>
                    </div>
                    {getTemplatedContent(notification)}
                </>
            ) : (
                <>Select a notification.</>
            )}
        </div>
    );
};

export default NotificationDetails;
